import React, { useEffect, useState } from 'react';
import './CapstoneOverview.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';

const binaryStatus = cond => {
  return cond ? "Completed" : "Pending"
}
const getStatus = prog => {
  let ret = "In-Progress"
  if (prog === 100) {
    ret = "Completed"
  }
  else if (prog === 0) {
    ret = "Pending"
  }
  return ret;
}
const CapstoneOverview = (props) => {
  // Sample data for the milestones
  const [publishing, setPublishing] = useState({
    title: 'Capstone Challenge Publishing', status: binaryStatus(1), progress: 100
  })
  const [formation, setFormation] = useState({
    title: 'Team Formation', status: binaryStatus(0), progress: 0
  })

  const [approval, setApproval] = useState({
    title: 'Idea Approval ', status: binaryStatus(0), progress: 0
  })

  const [displayBoard, setDisplayBoard] = useState({
    title: 'Display Board ', status: binaryStatus(0), progress: 0,
  })

  const [BMC, setBMC] = useState({
    title: 'BMC ', status: binaryStatus(0), progress: 0,
  })

  const [portfolio1, setPortfolio1] = useState({
    title: 'Capstone Portfolio Section I ', status: binaryStatus(0), progress: 0,
  })

  const [portfolio2, setPortfolio2] = useState({
    title: 'Portfolio Section II ', status: binaryStatus(0), progress: 0,
  })

  const [portfolio3, setPortfolio3] = useState({
    title: 'Portfolio Section III ', status: binaryStatus(0), progress: 0,
  })

  const [portfolio4, setPortfolio4] = useState({
    title: 'Portfolio Section IV ', status: binaryStatus(0), progress: 0,
  })

  const [prototype, setPrototype] = useState({
    title: 'Prototype ', status: binaryStatus(0), progress: 0,
  })

  const [journal1, setJournal1] = useState({
    title: 'Capstone Journal 1 ', status: binaryStatus(0), progress: 0,
  })

  const [journal2, setJournal2] = useState({
    title: 'Capstone Journal 2 ', status: binaryStatus(0), progress: 0,
  })

  const [journal3, setJournal3] = useState({
    title: 'Capstone Journal 3 ', status: binaryStatus(0), progress: 0,
  })

  const [journal4, setJournal4] = useState({
    title: 'Capstone Journal 4 ', status: binaryStatus(0), progress: 0,
  })

  useEffect(() => {
    setFormation(x => ({
      ...x,
      status: binaryStatus(props.inGroup),
      progress: (props.inGroup) ? 100 : 0
    }))
  }, [props.inGroup])

  useEffect(() => {
    setApproval(x => ({
      ...x,
      status: binaryStatus((props.displayBoardStatus - 0) === 1),
      progress: ((props.displayBoardStatus - 0) === 1) ? 100 : 0
    }))
  }, [props.displayBoardStatus])


  useEffect(() => {

    Swal.showLoading();
    axios.get(`${BASE_URL}/capstone/overview/getoverview.php`)
      .then(res => {
        if (res?.data?.data) {
          const res_data_data = res?.data?.data;
          // console.log(res_data_data)

          let property = "displayBoard";
          if (res_data_data.hasOwnProperty(property)) {

            // console.log(res_data_data[property])
            // console.log(property)
            // console.log(res_data_data.hasOwnProperty(property))

            // if (res_data_data.hasOwnProperty(`${property}_last_ts`)){

            // }
            setDisplayBoard(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((res_data_data.hasOwnProperty(`${property}_last_ts`)) ? { ts: res_data_data[`${property}_last_ts`] } : {})
            }))
          }
          property = "BMC";
          if (res_data_data.hasOwnProperty(property)) {
            setBMC(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((res_data_data.hasOwnProperty(`${property}_last_ts`)) ? { ts: res_data_data[`${property}_last_ts`] } : {})
            }))
          }
          property = "portfolio_last_ts";
          let portfolio_last_ts = null
          if (res_data_data.hasOwnProperty(property)) {
            portfolio_last_ts = res_data_data[property]
          }
          property = "portfolio1";
          if (res_data_data.hasOwnProperty(property)) {
            setPortfolio1(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((portfolio_last_ts) ? { ts: portfolio_last_ts } : {})
            }))
          }
          property = "portfolio2";
          if (res_data_data.hasOwnProperty(property)) {
            setPortfolio2(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((portfolio_last_ts) ? { ts: portfolio_last_ts } : {})
            }))
          }
          property = "portfolio3";
          if (res_data_data.hasOwnProperty(property)) {
            setPortfolio3(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((portfolio_last_ts) ? { ts: portfolio_last_ts } : {})
            }))
          }
          property = "portfolio4";
          if (res_data_data.hasOwnProperty(property)) {
            setPortfolio4(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((portfolio_last_ts) ? { ts: portfolio_last_ts } : {})
            }))
          }
          property = "prototype";
          if (res_data_data.hasOwnProperty(property)) {
            setPrototype(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((res_data_data.hasOwnProperty(`${property}_last_ts`)) ? { ts: res_data_data[`${property}_last_ts`] } : {})
            }))
          }
          property = "journal1";
          if (res_data_data.hasOwnProperty(property)) {
            setJournal1(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((res_data_data.hasOwnProperty(`${property}_last_ts`)) ? { ts: res_data_data[`${property}_last_ts`] } : {})
            }))
          }
          property = "journal2";
          if (res_data_data.hasOwnProperty(property)) {
            setJournal2(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((res_data_data.hasOwnProperty(`${property}_last_ts`)) ? { ts: res_data_data[`${property}_last_ts`] } : {})
            }))
          }
          property = "journal3";
          if (res_data_data.hasOwnProperty(property)) {
            setJournal3(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((res_data_data.hasOwnProperty(`${property}_last_ts`)) ? { ts: res_data_data[`${property}_last_ts`] } : {})
            }))
          }
          property = "journal4";
          if (res_data_data.hasOwnProperty(property)) {
            setJournal4(x => ({
              ...x,
              status: getStatus(res_data_data[property] - 0),
              progress: ((res_data_data[property] - 0)),
              ...((res_data_data.hasOwnProperty(`${property}_last_ts`)) ? { ts: res_data_data[`${property}_last_ts`] } : {})
            }))
          }
        }
        Swal.close();
      }).catch(err => {
        Swal.close();
      })

  }, [])

  return (
    <div className="overview">
      <h1>Capstone Project Overview</h1>

      {/* Timeline */}
      <div className="timeline">
        {[
          publishing,
          formation,
          ...((props.inGroup) ? [
            approval,
            ...[
              displayBoard,
              portfolio1,
              portfolio2,
              portfolio3,
              portfolio4,
              ...(((props.displayBoardStatus - 0) === 1) ? [
                BMC,
                prototype,
                journal1,
                journal2,
                journal3,
                journal4,
              ] : []),
            ].sort((a, b) => {
              // Check if both objects have a timestamp
              if (a.ts && b.ts) {
                // Parse timestamps to Date objects for comparison
                const dateA = new Date(a.ts);
                const dateB = new Date(b.ts);

                // Sort based on timestamp (ascending order)
                return dateA.getTime() - dateB.getTime();
              } else {
                // If one object lacks a timestamp, put it at the end
                return a.ts ? -1 : 1; // -1 for a with timestamp, 1 for b or both without
              }
            })
          ] : []),
        ].map((milestone, index) => (
          <div key={index} className={`milestone ${milestone.status}`}>
            <h3>{milestone.title}</h3>
            <p className={milestone.status}>Status: {milestone.status}</p>
            <div className="progress-bar">
              <div className={`progress ${milestone.status}`} style={{ width: `${milestone.progress}%` }}></div>
            </div>
          </div>
        ))}
      </div>

      {/* Charts & Graphs (can be integrated with a charting library) */}
      <div className="charts">
        <div className="chart" id="progress-chart">
          {/* Chart showing project progress */}
        </div>
        <div className="chart" id="status-chart">
          {/* Chart showing status of different components */}
        </div>
      </div>
    </div>
  );
};

export default CapstoneOverview;
